/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AppService } from '@services/app/app.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UiService } from '@services/ui/ui.service';
import { DestroyDirective } from '../destroy-abstract/destroy.abstract';
import { takeUntil } from 'rxjs/operators';
import { ContentService } from '@services/content/content.service';

@Component({
  selector: 'app-step-header',
  templateUrl: './step-header.component.html',
  styleUrls: ['./step-header.component.scss']
})
export class StepHeaderComponent extends DestroyDirective implements OnInit {
  /**
   * disabilita i bottoni
   */
  @Input() disabled: boolean;

  /**
   * nasconde il bottone back
   */
  @Input() hideBack: boolean;

  /**
   * nasconde la barra di progresso
   */
  @Input() hideProgress: boolean;

  /**
   * titolo dell'header
   */
  @Input() title: string;

  /**
   * numero di step
   */
  @Input() totalSteps: number;

  /**
   * index step attivo
   */
  @Input() activeIndex = 0;

  /**
   * emette evento di back
   */
  @Output() back = new EventEmitter<void>();

  /**
   * url del logo
   */
  logoUrl: string;

  /**
   * flag che determina l'osservazione del wizard
   */
  absolute: boolean;

  /**
   * messaggio di intro per la applicazione
   */
  appIntroMessage: string;

  constructor(
    private uiService: UiService,
    private appService: AppService,
    private contentService: ContentService
  ) {
    super();
  }

  ngOnInit() {
    this.watchContentCode();
    this.readConfig();
  }

  /**
   * apre modale di state
   */
  openState(): void {
    this.uiService.openModalState();
  }

  /**
   * imposta messaggio di intro per la applicazione (per funzione ARIA)
   */
  private watchContentCode(): void {
    this.contentService
      .getContentPageWhenChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe(page => {
        this.appIntroMessage =
          !!page && !!page.code ? `intro_${page.code}` : 'intro';
      });
  }

  /**
   * legge i valori del config
   */
  private readConfig(): void {
    const config = this.appService.getConfig();

    this.logoUrl = config.theme.bannerUrl || config.theme.logoUrl;
    this.absolute = config.wizard.progressBar === 'absolute';
  }
}
